export default {"src":"/_next/static/media/HTML.052ee48d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};